import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4daba80c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-container" }
const _hoisted_2 = {
  key: 0,
  class: "main"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "发票抬头", -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "tips mt4" }
const _hoisted_8 = {
  key: 0,
  class: "mt8"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "收票信息", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "收票人手机", -1))
const _hoisted_14 = { class: "content mt4" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "收件地址", -1))
const _hoisted_17 = { class: "content mt4" }
const _hoisted_18 = {
  key: 0,
  class: "info"
}
const _hoisted_19 = { class: "address" }
const _hoisted_20 = {
  key: 1,
  class: "info"
}
const _hoisted_21 = {
  key: 1,
  class: "footer xag-page__footer"
}
const _hoisted_22 = { class: "content" }

import { reactive, computed, ComputedRef, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, Router, useRoute } from 'vue-router'
import getRoute from '@/compositions/route'
import AppHeader from '@/components/Header.vue'
import { getUserInvoiceList, getUserAddressList } from '@/apis/invoice'
import { userAddressItem, InvoiceItem } from '@/types/invoice'
import {
  invoiceTypeColorMap,
  invoiceTypeTextMap,
  invoiceListStorageKey,
  addressListStorageKey,
  confirmUseInvoiceStorageKey,
  selectInoviceStorageKey,
  cacheFromStorageKey,
  selectAddressStorageKey,
} from './definition'
import { showToastFail, showToastLoading, clearToast } from '@/utils/tools'
import { Button } from 'vant'
import { setStorage } from '@/compositions/useMultiPlatformStorage'

interface invoiceInfoType {
  invoiceTypeColor: string
  invoiceTypeText: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'confirm',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const $router: Router = useRouter()
const { query } = getRoute()
const needInvoice: string = (query.value.needInvoice as string) || '0'
const showCancelBtn: ComputedRef<boolean> = computed(() => {
  let need = Number(needInvoice)
  return Boolean(need)
})

const store = useStore()
const userMobile = computed(() => store.state.userInfo?.mobile)
const isLoading = ref(false)

const page: {
  invoiceList: InvoiceItem[]
  addressList: userAddressItem[]
  currentInvoice: InvoiceItem | Record<string, unknown>
  currentAddress: userAddressItem | Record<string, unknown>
} = reactive({
  invoiceList: [],
  addressList: [],
  currentInvoice: {},
  currentAddress: {},
})
const invoiceInfo: ComputedRef<invoiceInfoType> = computed(() => {
  let currentInvoice = page.currentInvoice as InvoiceItem
  return {
    invoiceTypeColor: invoiceTypeColorMap.get(currentInvoice.invoice_type),
    invoiceTypeText: invoiceTypeTextMap.get(currentInvoice.invoice_type),
  }
})
const isNormalInvoice: ComputedRef<boolean> = computed(() => {
  let currentInvoice = page.currentInvoice
  return currentInvoice.invoice_type === 0
})
const isSpecialInvoice: ComputedRef<boolean> = computed(() => {
  let currentInvoice = page.currentInvoice
  return currentInvoice.invoice_type === 1
})
function invoiceClickHandle() {
  const invoiceList = page.invoiceList
  if (invoiceList.length) {
    // 去列表
    $router.push({
      name: 'invoice-select',
    })
  } else {
    // 去编辑页面
    $router.push({
      name: 'invoice-edit',
    })
  }
}
function toAddressList() {
  if (isNormalInvoice.value) {
    return
  }
  if (page.addressList.length) {
    $router.push({
      name: 'invoice-address-list',
    })
  } else {
    $router.push({
      name: 'invoice-address-edit',
    })
  }
}
function confirmUse() {
  let invoiceGuid = page.currentInvoice.guid
  let invoiceType = page.currentInvoice.invoice_type
  if (!invoiceGuid) {
    showToastFail('未选择发票')
    return
  }
  if (invoiceType === 1 && !page.currentAddress.guid) {
    showToastFail('未选择收件地址')
    return
  }
  setStorage(confirmUseInvoiceStorageKey, {
    invoice: { ...page.currentInvoice },
    address: { ...page.currentAddress },
    mobile: userMobile.value,
    needInvoice: true,
  })
  $router.go(-1)
}
function cancelUse() {
  setStorage(confirmUseInvoiceStorageKey, {
    needInvoice: false,
  })
  $router.go(-1)
}
async function initInvoice() {
  showToastLoading()
  isLoading.value = true
  let storageStr = sessionStorage.getItem(invoiceListStorageKey)
  let data
  if (storageStr) {
    data = JSON.parse(storageStr)
  } else {
    try {
      data = await getUserInvoiceList()
      sessionStorage.setItem(invoiceListStorageKey, JSON.stringify(data))
    } catch (e) {
      showToastFail(e && e.message)
    }
  }
  let selectStorageGuid = sessionStorage.getItem(selectInoviceStorageKey)
  if (data) {
    let defaultItem
    let selectedItem
    for (let i = 0; i < data.length; i++) {
      if (data[i].default) {
        defaultItem = data[i]
      }
      if (data[i].guid === selectStorageGuid) {
        selectedItem = data[i]
      }
    }
    page.currentInvoice = selectedItem || defaultItem || data[0] || {}
    page.invoiceList = data
  }
  isLoading.value = false
  clearToast()
}
async function initAddress() {
  let storageStr = sessionStorage.getItem(addressListStorageKey)
  let selectStorageStr = sessionStorage.getItem(selectAddressStorageKey)
  let data: userAddressItem[]
  if (storageStr) {
    data = JSON.parse(storageStr)
  } else {
    try {
      data = await getUserAddressList()
      sessionStorage.setItem(addressListStorageKey, JSON.stringify(data))
    } catch (e) {
      showToastFail(e && e.message)
    }
  }
  let selectedAddressGuid = selectStorageStr ? JSON.parse(selectStorageStr).guid : ''
  if (data) {
    const normalCurrentAddress =
      data.filter((item: userAddressItem) => item.default)[0] || data[0] || {}
    const selectCurrentAddress = selectedAddressGuid
      ? data.filter((item: userAddressItem) => item.guid === selectedAddressGuid)[0]
      : null
    page.currentAddress = selectCurrentAddress || normalCurrentAddress
    page.addressList = data
  }
}
initInvoice()
initAddress()
sessionStorage.removeItem(cacheFromStorageKey)

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: "发票" }),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "invoice-block",
              onClick: invoiceClickHandle
            }, [
              _createElementVNode("div", _hoisted_4, [
                (page.invoiceList.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "新增发票抬头"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", {
                          style: _normalizeStyle('color:' + _unref(invoiceInfo).invoiceTypeColor)
                        }, "[" + _toDisplayString(_unref(invoiceInfo).invoiceTypeText) + "]", 5),
                        _createElementVNode("span", null, _toDisplayString(page.currentInvoice.header), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(page.currentInvoice.taxpayer_no), 1)
                    ], 64))
              ]),
              _createVNode(_component_van_icon, {
                name: "arrow",
                class: "arrow-item"
              })
            ])
          ]),
          (page.invoiceList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  (_unref(isNormalInvoice))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "普通发票提供电子版，将通过短信发送"))
                    : _createCommentVNode("", true),
                  (_unref(isSpecialInvoice))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "增值税专用发票提供纸质版，将通过快递邮寄"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "address-block",
                  onClick: toAddressList
                }, [
                  (_unref(isNormalInvoice))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(userMobile)), 1)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(isSpecialInvoice))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          (page.addressList.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("div", null, _toDisplayString(page.currentAddress.name) + " " + _toDisplayString(page.currentAddress.phone), 1),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(page.currentAddress.area_name) + " " + _toDisplayString(page.currentAddress.area_address), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, "新增收件地址")),
                          _createVNode(_component_van_icon, {
                            name: "arrow",
                            class: "arrow-item"
                          })
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_unref(Button), {
              block: "",
              class: "confirm-button",
              onClick: confirmUse
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定发票申请")
              ]),
              _: 1
            }),
            (!_unref(showCancelBtn))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  block: "",
                  onClick: cancelUse
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("不开发票")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})